import React, {FC, useEffect} from 'react';

type Props = {
  options: string[];
  mode: string;
  select(mode: string): void;
};

export const TabbedButtons: FC<Props> = ({options, mode, select}) => {
  useEffect(() => {
    if (!mode) {
      select(options[0]);
    }
  }, [mode, options, select]);

  return (
    <div className="flex flex-row">
      {options.map((o, i) => {
        return <TabButton key={i} label={o} selected={o === mode} select={() => select(o)} isLast={i === options.length} />;
      })}
    </div>
  );
};

type TabButtonProps = {
  label: string;
  selected: boolean;
  select(): void;
  isLast: boolean;
};

const TabButton: FC<TabButtonProps> = ({selected, select, label, isLast}) => (
  <button className={`border-b-2 ${selected && 'border-b-blue-600'} flex flex-1 justify-center py-5 ${!isLast && 'border-r'}`} onMouseDown={select}>
    <div style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
      <h4 className="text-center">{label}</h4>
    </div>
  </button>
);
